@if (canShow()) {
  @if (field.input_type === FieldInputType.COMPARE_VALUE) {
    <app-edit-field-compare
      [ngClass]="{'moreThanOneSubField': subFieldIndex > 0}"
      [displayRequiredIndication]="displayRequiredIndication"
      [sectionsContainer]="sectionsContainer"
      [field]="field"
      [parentIndex]="parentIndex"
      [index]="index"
    ></app-edit-field-compare>
  } @else if (field.input_type === FieldInputType.META_OPERATION_FIELD) {
    <app-edit-field-meta-operation-field
      [ngClass]="{'moreThanOneSubField': subFieldIndex > 0}"
      [displayRequiredIndication]="displayRequiredIndication"
      [sectionsContainer]="sectionsContainer"
      [field]="field"
      [setAddChoice]="sectionsContainer.rootObject['set_add_choice']"
      [parentIndex]="parentIndex"
      [index]="index"
    ></app-edit-field-meta-operation-field>
  }
  @else {
    <app-edit-field
      [ngClass]="{'moreThanOneSubField': subFieldIndex > 0}"
      [displayRequiredIndicaton]="displayRequiredIndication"
      [sectionsContainer]="sectionsContainer"
      [grandParentObject]="grandParentObject"
      [object]="object"
      [field]="field"
      [index]="index"
      [parentIndex]="parentIndex"
      [grandparentIndex]="grandparentIndex"
    ></app-edit-field>
  }
}
